import React, { SVGProps } from "react";

function TsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <rect width="38" height="38" x="1" y="1" fill="#FFF" rx="2" />
        <path
          fill="#009D9B"
          d="M32.88 3H4c-.552 0-1 .448-1 1v15.81c3.58 1.381 7.365 2.158 11.2 2.3 2.297-2.429 4.767-4.688 7.39-6.76C26.24 11.46 31 7.47 32.88 3zM26.36 20.5c.56-.17 1.13-.35 1.7-.55 3.117-1.125 6.112-2.563 8.94-4.29V9.91c-2.83 4.01-6.86 7.43-10.64 10.59zM17.72 29.1c-.167.29-.307.595-.42.91-.717 2.26-.978 4.639-.77 7H36c.552 0 1-.448 1-1v-12.3c-2.13 1.079-4.324 2.027-6.57 2.84-4.088 1.473-8.37 2.332-12.71 2.55zM10.32 28.81c-2.482-.316-4.93-.848-7.32-1.59V36c0 .552.448 1 1 1h5.51c-.179-2.756.095-5.523.81-8.19z"
        />
        <path
          fill="#D6D7D7"
          fillRule="nonzero"
          d="M10.66 27.67c.809-2.066 2.007-3.957 3.53-5.57-1.1 0-2.16-.13-3.15-.26-1.546 1.912-2.578 4.187-3 6.61.73.13 1.5.24 2.29.35.09-.38.2-.8.33-1.13zM26.37 20.48l-.31.27c-3.41 2.84-6.91 5.77-8.34 8.32 1.22-.06 2.48-.15 3.77-.33 2.31-3.61 6.64-7.77 8.66-9.61-.85.35-1.58.63-2.1.81-.52.18-1.12.37-1.68.54z"
        />
        <path
          fill="#D6D7D7"
          d="M9.51 37h1.9c2.15-.74 5.07-1.93 5.07-1.93.017-.847.09-1.692.22-2.53-2.57 1.35-7 1.85-7.22 1.87-.02.85-.02 1.73.03 2.59z"
        />
        <path
          fill="#502B76"
          d="M28.69 21.71c-8.296 3.005-17.378 3.03-25.69.07v3.49c4.078 1.33 8.34 2.005 12.63 2 4.832-.01 9.626-.855 14.17-2.5.848-.307 1.287-1.242.98-2.09-.307-.848-1.242-1.287-2.09-.98v.01z"
        />
        <path
          fill="#F9B67E"
          fillRule="nonzero"
          d="M23 20.4c-.686.002-1.3-.427-1.535-1.072-.235-.644-.041-1.368.485-1.808l.85-.71c2.83-2.243 5.504-4.68 8-7.29.602-.671 1.634-.727 2.305-.125.671.602.727 1.634.125 2.305-2.588 2.732-5.365 5.278-8.31 7.62L24 20c-.278.243-.63.385-1 .4z"
        />
        <path
          fill="#EA5A60"
          fillRule="nonzero"
          d="M24.21 17.72c-.278-.332-.677-.54-1.108-.577-.432-.038-.86.098-1.192.377-4.38 3.67-8.12 7-9.45 10.76-.436 1.241-.741 2.525-.91 3.83-.21 1.621-.27 3.258-.18 4.89h3.27c-.093-1.484-.047-2.974.14-4.45.145-1.079.396-2.14.75-3.17 1.06-3 4.47-6 8.48-9.36.332-.278.54-.677.577-1.108.038-.432-.098-.86-.377-1.192z"
        />
        <path
          fill="#FFF"
          d="M28.62 37c2.921-1.68 5.721-3.56 8.38-5.63v-9.22C29.565 28.961 20.707 34.034 11.07 37h17.55z"
        />
        <path
          fill="#FDD79A"
          fillRule="nonzero"
          d="M33.28 27.75c-5.061 3.819-10.62 6.93-16.52 9.25h7.9c3.716-1.905 7.26-4.13 10.59-6.65.718-.552.852-1.582.3-2.3-.552-.718-1.582-.852-2.3-.3h.03z"
        />
        <path
          fill="#A02E80"
          d="M37 17.85c-2.65 1.53-5.431 2.822-8.31 3.86-.853.302-1.3 1.237-1 2.09.23.648.842 1.081 1.53 1.08.191 0 .38-.033.56-.1 2.478-.893 4.891-1.959 7.22-3.19v-3.74z"
        />
        <path
          fill="#FDD79A"
          d="M37 4c0-.552-.448-1-1-1h-1.11c-.943 2.426-2.357 4.642-4.16 6.52-.601.669-.547 1.698.12 2.3.297.273.687.423 1.09.42.465.002.909-.194 1.22-.54 1.51-1.636 2.801-3.46 3.84-5.43V4z"
        />
        <path
          fill="#F9B67E"
          d="M37 24.67c-1.907 1.688-3.91 3.264-6 4.72-.479.334-.743.898-.693 1.48.05.581.406 1.092.935 1.34.529.247 1.15.194 1.628-.14 1.42-1 2.78-2 4.12-3.13l.01-4.27z"
        />
        <path
          fill="#442563"
          fillRule="nonzero"
          d="M8.47 26.65c.78.14 1.62.25 2.48.35.485-1.113 1.095-2.166 1.82-3.14-1-.08-2-.2-2.91-.34-.585.985-1.052 2.035-1.39 3.13zM23.05 26.6c1.194-1.496 2.466-2.928 3.81-4.29-1.233.377-2.485.69-3.75.94-1.424 1.197-2.76 2.493-4 3.88 1.28-.13 2.59-.29 3.94-.53z"
        />
        <path
          fill="#FEFEFE"
          fillRule="nonzero"
          d="M17.38 10.54c-.19-.28-.448-.507-.75-.66-.355-.17-.723-.314-1.1-.43-.283-.083-.558-.194-.82-.33-.156-.078-.256-.236-.26-.41-.003-.158.071-.308.2-.4.177-.107.384-.156.59-.14.559.021 1.102.194 1.57.5l.69-1.2c-.683-.478-1.496-.737-2.33-.74-.624-.044-1.243.14-1.74.52-.416.392-.636.95-.6 1.52-.016.378.085.752.29 1.07.177.257.414.466.69.61.325.153.66.286 1 .4.28.087.5.167.66.24.149.055.282.144.39.26.107.11.165.257.16.41 0 .186-.085.363-.23.48-.203.138-.445.205-.69.19-.294-.007-.587-.05-.87-.13-.37-.113-.73-.253-1.08-.42l-.57 1.25c.738.476 1.592.739 2.47.76.716.068 1.431-.14 2-.58.45-.41.69-1.002.65-1.61.019-.41-.093-.817-.32-1.16zM6.8 8.33L8.62 8.33 8.62 13.81 10.28 13.81 10.28 8.33 12.09 8.33 12.09 6.81 6.8 6.81z"
        />
        <path
          fill="#E5E5E5"
          fillRule="nonzero"
          d="M37 1c1.105 0 2 .895 2 2v34c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2V3c0-1.105.895-2 2-2h34m0-1H3C1.343 0 0 1.343 0 3v34c0 1.657 1.343 3 3 3h34c1.657 0 3-1.343 3-3V3c0-1.657-1.343-3-3-3z"
        />
      </g>
    </svg>
  );
}

export default TsIcon;
